import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";

import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import NumberFormat from "react-number-format";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

let isLoading = "false";
class Invoice extends Component {
  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="invoice">
          <header class="clearfix">
            <h1>INVOICE 3-2-1</h1>
            <div id="company" class="clearfix">
              <div>Company Name</div>
              <div>
                455 Foggy Heights,
                <br /> AZ 85004, US
              </div>
              <div>(602) 519-0450</div>
              <div>
                <a href="mailto:company@example.com">company@example.com</a>
              </div>
            </div>
            <div id="project">
              <div>
                <span>PROJECT</span> Website development
              </div>
              <div>
                <span>CLIENT</span> John Doe
              </div>
              <div>
                <span>ADDRESS</span> 796 Silver Harbour, TX 79273, US
              </div>
              <div>
                <span>EMAIL</span>{" "}
                <a href="mailto:john@example.com">john@example.com</a>
              </div>
              <div>
                <span>DATE</span> August 17, 2015
              </div>
              <div>
                <span>DUE DATE</span> September 17, 2015
              </div>
            </div>
          </header>
          <main>
            <table>
              <thead>
                <tr>
                  <th class="service">SERVICE</th>
                  <th class="desc">DESCRIPTION</th>
                  <th>PRICE</th>
                  <th>QTY</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="service">Design</td>
                  <td class="desc">
                    Creating a recognizable design solution based on the
                    company's existing visual identity
                  </td>
                  <td class="unit">$40.00</td>
                  <td class="qty">26</td>
                  <td class="total">$1,040.00</td>
                </tr>
                <tr>
                  <td class="service">Development</td>
                  <td class="desc">
                    Developing a Content Management System-based Website
                  </td>
                  <td class="unit">$40.00</td>
                  <td class="qty">80</td>
                  <td class="total">$3,200.00</td>
                </tr>
                <tr>
                  <td class="service">SEO</td>
                  <td class="desc">
                    Optimize the site for search engines (SEO)
                  </td>
                  <td class="unit">$40.00</td>
                  <td class="qty">20</td>
                  <td class="total">$800.00</td>
                </tr>
                <tr>
                  <td class="service">Training</td>
                  <td class="desc">
                    Initial training sessions for staff responsible for
                    uploading web content
                  </td>
                  <td class="unit">$40.00</td>
                  <td class="qty">4</td>
                  <td class="total">$160.00</td>
                </tr>
                <tr>
                  <td colspan="4">SUBTOTAL</td>
                  <td class="total">$5,200.00</td>
                </tr>
                <tr>
                  <td colspan="4">TAX 25%</td>
                  <td class="total">$1,300.00</td>
                </tr>
                <tr>
                  <td colspan="4" class="grand total">
                    GRAND TOTAL
                  </td>
                  <td class="grand total">$6,500.00</td>
                </tr>
              </tbody>
            </table>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.citypasswordReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
  };
};
export default compose(withRouter, connect(mapStateToProps))(Invoice);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/Invoice.js